import Marquee from "react-fast-marquee";

export const BrandMarquee = ({ text }) => {
  const item = text || "AMERICAN DREAM  •  ";
  return (
    <section className="relative py-8 border-y border-white/10 bg-ad-surface overflow-hidden" data-testid="brand-marquee">
      <Marquee speed={45} gradient={false} autoFill>
        <span className="font-display text-5xl sm:text-7xl uppercase tracking-tight text-stroke px-6">
          {item}
        </span>
      </Marquee>
    </section>
  );
};
